import { parse } from "date-fns";

import { ICannedResponse } from "store/entities/canned-responses";

export default abstract class CannedResponseSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }): ICannedResponse {
    const deserialized: ICannedResponse = {
      id: data.ID,
      text: data.text,
      richTextObj: data.richTextObj,
      teamId: data.teamID,
      shortcuts: data.shortcuts,
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      createdByType: data.createdByType,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
      attachments: data.attachments || [],
    };
    return deserialized;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeList(list: any): ICannedResponse[] {
    return list.map(CannedResponseSerializer.deserialize);
  }
}
